import { useMutation } from "@apollo/client";
import CreateTranslationMutation from "../graphql/mutations/CreateTranslationMutation.graphql";
import UpdateTranslationMutation from "../graphql/mutations/UpdateTranslationMutation.graphql";
import DeleteTranslationsMutation from "../graphql/mutations/DeleteTranslationsMutation.graphql";
import RestoreTranslationsMutation from "../graphql/mutations/RestoreTranslationsMutation.graphql";
import UpdateTranslationWordsMutation from "../graphql/mutations/UpdateTranslationWordsMutation.graphql";
import SyncTranslationWordsMutation from "../graphql/mutations/SyncTranslationWordsMutation.graphql";
import type {
  CreateTranslationMutationType,
  UpdateTranslationMutationType,
  DeleteTranslationsMutationType,
  RestoreTranslationsMutationType,
  UpdateTranslationWordsMutationType,
  SyncTranslationWordsMutationType,
} from "@/types/graphql/admin.generated";

export function useCreateTranslationMutation() {
  return useMutation<CreateTranslationMutationType>(CreateTranslationMutation);
}

export function useUpdateTranslationMutation() {
  return useMutation<UpdateTranslationMutationType>(UpdateTranslationMutation);
}

export function useDeleteTranslationsMutation() {
  return useMutation<DeleteTranslationsMutationType>(
    DeleteTranslationsMutation
  );
}

export function useRestoreTranslationsMutation() {
  return useMutation<RestoreTranslationsMutationType>(
    RestoreTranslationsMutation
  );
}

export function useUpdateTranslationWordsMutation() {
  return useMutation<UpdateTranslationWordsMutationType>(
    UpdateTranslationWordsMutation
  );
}

export function useSyncTranslationWordsMutation() {
  return useMutation<SyncTranslationWordsMutationType>(
    SyncTranslationWordsMutation
  );
}
